import { render, staticRenderFns } from "./CreateItemForm.vue?vue&type=template&id=654c7974&scoped=true&"
import script from "./CreateItemForm.vue?vue&type=script&lang=ts&"
export * from "./CreateItemForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreateItemForm.vue?vue&type=style&index=0&id=654c7974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654c7974",
  null
  
)

export default component.exports